import { Button, Typography } from 'antd'
import { HomeOutlined } from '@ant-design/icons'
import { useTranslation } from 'react-i18next'
import { useLocation } from 'react-router-dom'
import { useAppNavigate } from '@/hooks'
import SystemHeader from '@/widgets/layout/SystemHeader'

const NotFound = () => {
  const { t } = useTranslation('common')
  const navigate = useAppNavigate()
  const location = useLocation()

  return (
    <div className="min-h-screen bg-gray-100">
      <SystemHeader breadcrumbs={[{ label: t('notFound.title') }]} />
      <main className="max-w-3xl mx-auto px-6 py-16">
        <div className="bg-white rounded-xl shadow-lg p-10 text-center">
          <div className="text-[96px] leading-none font-bold text-blue-500 mb-2">404</div>
          <Typography.Title level={3} className="!mb-3">
            {t('notFound.title')}
          </Typography.Title>
          <Typography.Paragraph type="secondary" className="!mb-2">
            {t('notFound.description')}
          </Typography.Paragraph>
          <Typography.Text code className="!text-xs !text-gray-400 break-all">
            {location.pathname}
          </Typography.Text>
          <div className="mt-8">
            <Button type="primary" icon={<HomeOutlined />} onClick={() => navigate('home')}>
              {t('notFound.backToHome')}
            </Button>
          </div>
        </div>
      </main>
    </div>
  )
}

export default NotFound
